<section id="skill-section" class="skills-development-section dark">
  <p class="title">Cada nivel ayuda a desarrollar distintas habilidades</p>
  <div class="container">
    <div class="cards" #cardsAnimation>
      <div>
        <h3>Level 1</h3>
        <p>Trabajamos en consolidar tus habilidades de 
          programación en C# o Java, trabajando en la 
          resolución de problemas y abstracción. Con el fin de producir código mantenible 
          y extensible.
        </p>
        <a href="{{ formLevel1Url }}" target="_blank" class="register-button">
          <button>Inscribirme</button>
        </a>
      </div>
      <div>
        <h3>Level 2</h3>
        <p>Nos especializaremos en tecnologías de actual 
          demanda laboral a nivel internacional y nos 
          integraremos en un equipo de desarrollo de software. 
          Realizaremos el diseño e implementación de un proyecto 
          usando una de estas tecnologías: .Net Core, Java, Python 
          para backend. Y ReactJs para frontend.</p>
          <a href="{{ formLevel2Url }}" target="_blank" class="register-button">
            <button>Inscribirme</button>
          </a>
      </div>
      <div>
        <h3>Level 3</h3>
        <p class="third">Hasta aquí hemos desarrollado las habilidades 
          técnicas necesarias, pero, ¿estás listo para trabajar en un 
          proyecto de desarrollo de software junto a un equipo? 
          Comprobémoslo al formar parte de un equipo y vivir el ciclo de 
          desarrollo completo basado en Scrum, siguiendo las prácticas del 
          desarrollo de software comercial.</p>
          <a href="{{ formLevel3Url }}" target="_blank" class="register-button">
            <button>Inscribirme</button>
          </a>
      </div>
    </div>
  </div>
</section>
